import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UserTable = () => {
    const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');  // State for search query

    useEffect(() => {
        // Fetch data from the API
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users`)
            .then((response) => {
                setUserData(response.data);  // Set the data in state
                setLoading(false);  // Set loading to false once data is fetched
            })
            .catch((error) => {
                setError(error.message);  // Set error in case of failure
                setLoading(false);
            });
    }, []);  // Empty dependency array means it runs once when the component mounts

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    // Filter userData based on the search query
    const filteredData = userData.filter(user =>
        user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.designation.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
        user.email.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
        user.department.deptName.toLowerCase().startsWith(searchQuery.toLowerCase())
    );

    return (
        <div className="container mt-4">
            <h2 className="mb-4 text-center">Users</h2>

            {/* Search Input */}
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Username, Designation, Email or Dept"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>User ID</th>
                            <th>Username</th>
                            <th>Designation</th>
                            <th>Contact Number</th>
                            <th>Email</th>
                            <th>Photo</th>
                            <th>Specialization</th>
                            <th>Department</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((user, index) => (
                            <tr key={index}>
                                <td>{user.userId}</td>
                                <td>{user.username}</td>
                                <td>{user.designation}</td>
                                <td>{user.contactNumber}</td>
                                <td>{user.email}</td>
                                <td>
                                    <img
                                        src={user.photo}
                                        alt={user.username}
                                        className="img-thumbnail"
                                        width="100"
                                    />
                                </td>
                                <td>{user.specialization}</td>
                                <td>{user.department.deptName}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UserTable;
